import React, { Component } from "react"
import { withRouter } from "react-router"
import { Helmet } from "react-helmet"
import "./App.css"
import { withStyles } from "@material-ui/core/styles"
import { connect } from "react-redux"
import { compose } from "recompose"
import Routes from "../Routes"
import MessageDrawer from "../MessageDrawer"
import Snackbar from "@material-ui/core/Snackbar"
import HiddenLoginModal from "../HiddenLoginModal"
import withWidth from "@material-ui/core/withWidth"
import { MuiThemeProvider } from "@material-ui/core/styles"
import billingTheme from "../../themes/billing"
import { closeSnackBar, openSnackBar } from "../../actions/snack-bar"
import { updateShootsArray } from "../../actions/shoots"
import {
  completeStripeAccount,
  getUser,
  refreshStripeUrl,
  toggleProfileDialog,
} from "../../actions/users"
import {
  setRefreshedUser,
  loginSuccess,
  refreshToken,
  setUser,
} from "../../actions/authentication"
import { isEmpty, isNil } from "lodash"
import CreateClientDialog from "../../components/CreateClientDialog"
import CreateProducerDialog from "../../components/CreateProducerDialog"
import ProfileDialog from "../../components/ProfileDialog"
import EditCompanyDialog from "../../components/EditCompanyDialog"
import CreateCompanyDialog from "../CreateCompanyDialog/index"
import PubNubController from "../PubNubController/index"
import { switchActiveCompany } from "../../actions/companies"
import Alert from "../Alert/index"
import BookingDialog from "../BookingDialog/index"
import ReferCrewDialog from "../ReferCrewDialog/index"
import ClaimModal from "../ClaimModal"
import PaymentModal from "../PaymentModal"
import CancelSubscriptionModal from "../CancelSubscriptionModal"
import AlreadyCanceledSubscriptionModal from "../AlreadyCanceledSubscriptionModal"
import MessageDialog from "../MessageDialog/index"
import SuggestPositionDialog from "../SuggestPositionDialog"
import ShootDialog from "../ShootDialog"
import BillingPaymentDialog from "../Billing/BillingDialogs/BillingPaymentDialog"
import SendBillingDialog from "../Billing/BillingDialogs/SendBillingDialog"
import DigitalSignatureDialog from "../Billing/BillingDialogs/DigitalSignatureDialog"
import ClickConfirmationDialog from "../Billing/BillingDialogs/ClickConfirmationDialog"
import FlaggingDialog from "../Billing/BillingDialogs/FlaggingDialog/index"
import CreateSoloDialog from "../Billing/BillingDialogs/CreateSoloDialog/index"
import ClientInvoiceLogsDialog from "../Billing/BillingDialogs/ClientInvoiceLogsDialog/index"
import AddSoloPositionDialog from "../Billing/BillingDialogs/AddSoloPositionDialog/index"
import AddDiscountDialog from "../Billing/BillingDialogs/AddDiscountDialog/index"
import ManageExpensesDialog from "../Billing/BillingDialogs/ManageExpensesDialog/index"
import LoginDialog from "../../components/LoginDialog"
import BillingAdjustmentDialog from "../Billing/BillingDialogs/BillingAdjustmentDialog/index"

const styles = theme => ({
  "@global": {
    a: {
      color: theme.palette.primary.main,
    },
  },
})

class App extends Component {
  constructor(props) {
    super(props)

    this.pubNub = null

    this.setPubNubRef = element => {
      this.pubNub = element
    }
  }

  componentDidMount() {
    if (
      this.props.authentication.token &&
      !isEmpty(this.props.authentication.authenticatedUser)
    ) {
      this.props
        .dispatch(getUser(this.props.authentication.authenticatedUser.id))
        .then(res => {
          // console.log('App.js res', res);
          this.props.dispatch(loginSuccess(res))
          this.props.dispatch(setRefreshedUser())
        })
    }

    const params = new URLSearchParams(this.props.location.search)
    const status = params.get("session")
    const stripeAccountId = params.get("account_id")

    let crewId = this.props.authentication.authenticatedUser.id
    if (status && stripeAccountId && crewId) {
      if (status === "completed") {
        this.props
          .dispatch(completeStripeAccount(stripeAccountId))
          .then(res => {
            this.props.dispatch(
              openSnackBar({ message: "Account linked with stripe" })
            )
            this.props.dispatch(
              toggleProfileDialog(true, {
                id: crewId,
              })
            )
          })
          .catch(err => {
            this.props.dispatch(
              openSnackBar({ message: "Error linking account with stripe" })
            )
            this.props.dispatch(
              toggleProfileDialog(true, {
                id: crewId,
              })
            )
          })
      } else {
        this.props
          .dispatch(refreshStripeUrl(stripeAccountId))
          .then(res => {
            window.open(res.data.url)
          })
          .catch(err => {
            this.props.dispatch(
              openSnackBar({ message: "Error resending url" })
            )
          })
      }
    }
  }
  doRefresh = () => {
    const deferred = new Promise((resolve, reject) => {
      this.props
        .dispatch(refreshToken())
        .then(() => {
          this.props
            .dispatch(getUser(this.props.authentication.authenticatedUser.id))
            .then(res => {
              this.props.dispatch(setUser(res))
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
        .catch(err => {
          reject(err)
        })
    })
    return deferred
  }
  handlePubNubMessage = message => {
    let snackBarMessage
    switch (message.text) {
      case "manager added":
        snackBarMessage =
          "You've been added as a manager to a new company, refresh to see it in your menu"
        this.doRefresh().then(res => {
          snackBarMessage = `You've been added as a manager to ${
            res.companies.find(c => c.id === parseInt(message.company_id, 10))
              .name
          }, you will see it in your menu`
          this.props.dispatch(
            openSnackBar({
              message: snackBarMessage,
            })
          )
        })
        break
      case "manager removed":
        snackBarMessage =
          "You've been removed as a manager from a company, refreshing in 6 seconds"
        const company = this.props.authentication.authenticatedUser.companies.find(
          c => c.id === parseInt(message.company_id, 10)
        )
        this.doRefresh()
          .then(res => {
            snackBarMessage = `You've been removed as a manager from ${
              company.name
            }, it has been removed from your menu`
            if (res.companies.length > 0) {
              this.props.dispatch(
                switchActiveCompany(
                  res.companies[0].id,
                  res.companies[0].managers.find(
                    m => m.id === this.props.authentication.authenticatedUser.id
                  )
                    ? 1
                    : 2
                )
              )
            } else {
              this.props.dispatch(switchActiveCompany(null, ""))
            }
            this.props.dispatch(
              openSnackBar({
                message: snackBarMessage,
              })
            )
          })
          .catch(() => {
            setTimeout(() => {
              window.location.reload()
            }, 6000)
            this.props.dispatch(
              openSnackBar({
                message: snackBarMessage,
              })
            )
          })
        break
      case "shoot":
        if (
          !isEmpty(message.shoot) &&
          message.sender !== this.props.authentication.authenticatedUser.id
        ) {
          // Removing snackbar notification that pops of every time any shoot is updated (For non production environments)
          // if (process.env.NODE_ENV === "production") {
          //   snackBarMessage = "Shoot updated: " + message.shoot.name
          //   this.props.dispatch(
          //     openSnackBar({
          //       message: snackBarMessage,
          //     })
          //   )
          // }
          this.props.dispatch(updateShootsArray(message.shoot))
        }
        break
      default:
    }
  }
  render() {
    const snackBarOrigin =
      this.props.width === "sm" || this.props.width === "xs"
        ? {
            vertical: "bottom",
            horizontal: "left",
          }
        : {
            vertical: "bottom",
            horizontal: "left",
          }
    return (
      <div className="App">
        <Helmet defaultTitle={this.props.pageTitle}>
          <link rel="canonical" href="https://crewmama.com" />
        </Helmet>
        <ProfileDialog history={this.props.history} />
        <PaymentModal />
        <CancelSubscriptionModal />
        <AlreadyCanceledSubscriptionModal />
        <EditCompanyDialog />
        <CreateCompanyDialog />
        <BookingDialog />
        <MessageDialog />
        <ReferCrewDialog />
        <Alert />
        <HiddenLoginModal />
        <ClaimModal />
        <SuggestPositionDialog />
        <ShootDialog createdClient={this.props.createdClient} />
        <CreateClientDialog />
        <CreateProducerDialog />
        {/* Billing side Dialogs wrapped in theme provider at this point */}
        <MuiThemeProvider theme={billingTheme}>
          <SendBillingDialog />
          <FlaggingDialog />
          <ClickConfirmationDialog />
          <DigitalSignatureDialog />
          <BillingPaymentDialog />
          <AddSoloPositionDialog />
          <CreateSoloDialog />
          <ClientInvoiceLogsDialog />
          <AddDiscountDialog />
          <ManageExpensesDialog />
          <BillingAdjustmentDialog />
          <LoginDialog history={this.props.history} />
        </MuiThemeProvider>
        <Snackbar
          anchorOrigin={snackBarOrigin}
          open={this.props.snackBar.open}
          onClose={() => this.props.dispatch(closeSnackBar())}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          autoHideDuration={this.props.snackBar.autoHideDuration}
          message={<span id="message-id"> {this.props.snackBar.message} </span>}
        />{" "}
        {this.props.messageDrawerVisible && <MessageDrawer />}{" "}
        {this.props.children} <Routes childProps={this.props} />{" "}
        {!window.location.href.includes("billing") &&
          !isEmpty(this.props.authentication.authenticatedUser) && (
            <PubNubController
              channelName={`users_channel_${
                this.props.authentication.authenticatedUser.id
              }`}
              ref={this.setPubNubRef}
              onAction={this.handlePubNubMessage}
            />
          )}{" "}
        {!window.location.href.includes("billing") &&
          !isNil(this.props.companies.activeCompany) && (
            <PubNubController
              channelName={`companies_channel_${
                this.props.companies.activeCompany
              }`}
              ref={this.setPubNubRef}
              onAction={this.handlePubNubMessage}
            />
          )}{" "}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    snackBar: state.snackBar,
    messageDrawerVisible: state.messageDrawer.visible,
    pageTitle: state.pageTitle,
    createdClient: state.users.createdClient,
    companies: state.companies,
  }
}

export default withRouter(
  compose(
    connect(mapStateToProps),
    withStyles(styles),
    withWidth()
  )(App)
)
